import React from "react";
import MetaData from "../../components/layout/MetaData";

/**
 * 创始人页面，展示创始人介绍并适配桌面端与移动端布局。
 */
export default function FounderPage() {
  return (
    <>
      <MetaData title="Our Founder" />
      <section className="creatyea-padding our-founder-page">
        <div className="our-founder-hero">
          <div className="our-founder-layout">
            <div className="our-founder-copy">
              <div className="our-founder-tags">
                <span className="our-founder-tag">One Woman</span>
                <span className="our-founder-tag">One Vision</span>
                <span className="our-founder-tag">Creatyea</span>
              </div>
              <h1 className="our-founder-title">
                The woman who made Creatyea
                <br />
                - Yophy Kwok
              </h1>
              <p className="our-founder-body">
                Born in Gui Yu, Shan Tou and raised among the electronics
                center of China. Yophy Kwok driven by a lifelong mission to
                create a better hardware for consumers.
              </p>
              <div className="our-founder-card">
                <p>
                  From Electronics to Hardware Design, Kwok&apos;s vision and
                  values remain at the heart of Creatyea today.
                </p>
              </div>
            </div>
            <div className="our-founder-image-col">
              <img
                src="/img/founder_yophy.png"
                alt="Yophy Kwok"
                className="our-founder-image"
              />
            </div>
          </div>
          <div className="our-founder-corner" aria-hidden="true"></div>
        </div>
      </section>
    </>
  );
}
